module.exports = __webpack_public_path__ + "img/reports.8beab1cf.svg";